export interface SuccessInfo {
  code: SuccessCode;
}

// NOTE: Success message codes are purely frontend logic
export enum SuccessCode {
  MailboxCreated = <any>'mailbox_created',
  AliasCreated = <any>'alias_created',
  AliasRemoved = <any>'alias_removed',
  PasswordChangeSuccess = <any>'change_password_success',
  PasswordRecoveryEmailMethodSuccess = <any>(
    'password_recovery_email_method_success'
  ),
  PasswordRecoverySmsMethodSuccess = <any>(
    'password_recovery_sms_method_success'
  ),
  PasswordRecoverySmsMethodActivateSuccess = <any>(
    'password_recovery_sms_method_activate_success'
  ),
}
